import React, { useEffect, useState } from "react";
import "./EditAgencyModal.css";
import AddAgencyModalLogo from "../../../assets/images/addAgencyModalLogo.svg";
import PhoneInput from "react-phone-input-2";
import { Button } from "primereact/button";
import * as yup from "yup";

import "react-phone-input-2/lib/bootstrap.css";
import { Formik, useFormik } from "formik";
import {
  updateUser,
} from "../../../services/user.service";
import { CommonInputField } from "../../common-input";
import useToast from "../../../context/toast.hook";
import { Toast } from "primereact/toast";

const phoneRegExp = /^\d{10}$/;

const usernamePattern = /^[a-zA-Z0-9-_]+$/;

const schema = yup.object().shape({
  name: yup.string().required("Agency Name is required"),
  contact: yup.string().required("Agency Contact is required"),
  email: yup.string().email("Must be valid Email"),
  agencyUserName: yup
    .string()
    .matches(
      usernamePattern,
      "Username can only contain alphabets, numbers, _ and -"
    )
    .required("Agency username is required"),
});
const EditUserModal = ({ toggleModal, agencyData }) => {

  const { errorToast, successToast, toastRef } = useToast();
  const [phoneNo, setPhoneNo] = useState();

  const [phoneError, setPhoneError] = useState(false);

  const initialValues = {
    name: agencyData?.name || "",
    contact: agencyData?.contact || "",
    email: agencyData?.email || "",
    agencyUserName: agencyData?.agencyUserName || "",
  };

  const handleSubmit = (values) => {
    if (!phoneNo || !phoneRegExp.test(phoneNo)) {
      setPhoneError(true);
      return;
    }
    setPhoneError(false);
    updateUser(agencyData?._id, { ...values, phone: phoneNo, role: "sub" })
      .then((res) => {
        successToast(res?.data?.message);
        toggleModal();
      })
      .catch((error) => {
        errorToast(error);
      });
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: initialValues,
    validationSchema: schema,
    onSubmit: (values) => {
      handleSubmit(values);
    },
  });

  useEffect(() => {
    if (agencyData && agencyData?.phone) {
      setPhoneNo(agencyData?.phone);
    }
  }, [agencyData]);

  return (
    <>
      <Toast ref={toastRef} />
      <div className="modalAgency">
        <div className="modalInternalsAgency">
          <img
            className="logoModalAgency"
            src={AddAgencyModalLogo}
            alt="ModalLogo"
          />
          <br />
          <span className="modalHeadingAgency">Edit Agency</span>
          <div className="inputFieldsFlexAgency">
            <div className="inputFieldBoxAgency">
              <strong> Name</strong>
              <br />
              <CommonInputField
                formik={formik}
                name="name"
                placeholder="OPTA"
              />
            </div>
            <div className="inputFieldBoxAgency">
              <strong>Username</strong>
              <br />
              <CommonInputField
                formik={formik}
                name="agencyUserName"
                placeholder="OPTA-123"
              />
            </div>
            <div className="inputFieldBoxAgency">
              <strong>Contact</strong>
              <br />
              <CommonInputField
                formik={formik}
                name="contact"
                placeholder="Charles"
              />
            </div>
            <div className="inputFieldBoxAgency">
              <strong>Phone</strong>
              <br />
              <PhoneInput
                country={"ca"}
                className={`block w-full ${phoneError ? "p-invalid" : ""}`}
                onChange={(phone) => setPhoneNo(phone)}
                value={phoneNo}
                name="phone"
                disableDropdown
                disableCountryCode
                onlyCountries={["ca"]}
                placeholder="(226) 123-4567"
              />
              {phoneError ? (
                <small id="email-help" className="p-error block">
                  Valid phone number is required
                </small>
              ) : null}
            </div>

            <div className="inputFieldBoxAgency">
              <label htmlFor="email" className="block text-800">
                <strong>Email</strong>
              </label>
              <CommonInputField
                formik={formik}
                name="email"
                disabled
                placeholder="xyz@opta.com"
              />

              <div className="addBackBoxAgency">
                <div className="addButton">
                  <Button
                    label="Update"
                    style={{
                      background: "#1C9894",
                      width: "140px",
                      border: "0",
                    }}
                    onClick={formik.handleSubmit}
                  />
                </div>
                <div className="addButton">
                  <Button
                    label="Back"
                    style={{
                      background: "#FFFFFF",
                      width: "140px",
                      color: "#1C9894",
                      marginLeft: "20px",
                      borderColor: "#1C9894",
                    }}
                    onClick={() => {
                      toggleModal(true);
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="overlay"
        onClick={() => {
          toggleModal(true);
        }}
      ></div>
    </>
  )
}

export default EditUserModal